export const table = `<div class="table rounded-md shadow-sm" padding="2" table-hover="true" table-striped="true" table-align="center">
    <table>
        <thead>
            <tr>
                <th>Head</th>
                <th>Head</th>
                <th>Head</th>
                <th>Head</th>
                <th>Head</th>
                <th>Head</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Cell</td>
                <td>Cell</td>
                <td>Cell</td>
                <td>Cell</td>
                <td>Cell</td>
                <td>Cell</td>
            </tr>
        </tbody>
    </table>
</div>`